import { render, staticRenderFns } from "./NationalInsuranceNumber.vue?vue&type=template&id=059801f3"
import script from "./NationalInsuranceNumber.vue?vue&type=script&lang=js"
export * from "./NationalInsuranceNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports